import React, { useState, useEffect } from 'react';

const Clients = () => {
  const [clientsData, setClientsData] = useState([]);
  const [statsData, setStatsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  const fetchClients = async () => {
    try {
      const response = await fetch('https://my-portfoli-backed.onrender.com/api/clients');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      
      if (data.status === 'success') {
          // تحويل بيانات العملاء إلى التنسيق المطلوب
          const formattedClients = data.data.clients.map(client => ({
            id: client._id,
            name: client.name,
            industry: client.typeArabic,
            testimonial:client.testimonial || "شهادة العميل غير متوفرة حالياً", // التعديل هنا
            logoText: client.name,
            logo: client.logo,
            isStrategic: client.isStrategic
          }));
          
          setClientsData(formattedClients);
          
          // تحويل بيانات الإحصائيات
          const formattedStats = [
          { number: `${data.data.stats.completedProjects}+`, label: "مشروع مكتمل" },
          { number: `${data.data.stats.totalProjects}+`, label: "إجمالي المشاريع" },
          { number: `${data.data.stats.inProgressProjects}+`, label: "مشاريع قيد التنفيذ" },
          { number: `${data.results}+`, label: "عدد العملاء" } // التعديل هنا
        ];
          
          setStatsData(formattedStats);
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching clients:', err);
        
        // استخدام بيانات افتراضية في حالة الخطأ
        setClientsData([
          {
            id: "1",
            name: "شركة التقنية المتقدمة",
            industry: "تكنولوجيا المعلومات",
            testimonial: "قدم عبدالله حلولاً برمجية استثنائية ساعدتنا على تطوير أعمالنا بشكل كبير.",
            logoText: "شعار شركة التقنية",
            isStrategic: true
          },
          {
            id: "2",
            name: "بنك الرياض",
            industry: "الخدمات المالية",
            testimonial: "التزامه بالجودة والوقت جعله شريكًا موثوقًا به لمشاريعنا التقنية.",
            logoText: "شعار بنك الرياض",
            isStrategic: false
          },
          {
            id: "3",
            name: "مستشفى الملك فيصل",
            industry: "الرعاية الصحية",
            testimonial: "نظام إدارة المستشفيات الذي طوره أحدث نقلة نوعية في خدمتنا للمرضى.",
            logoText: "شعار المستشفى",
            isStrategic: false
          }
        ]);
        
      setStatsData([
        { number: "50+", label: "عميل راضٍ" },
        { number: "120+", label: "مشروع مكتمل" },
        { number: "15+", label: "عدد العملاء" }, // التعديل هنا
        { number: "5", label: "سنوات خبرة" }
      ]);
    } finally {
      setLoading(false);
    }
    };

    fetchClients();
  }, []);

  const styles = {
    container: {
      backgroundColor: '#ffffff',
      color: '#333333',
      minHeight: '100vh',
      padding: '4rem 2rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      lineHeight: '1.6'
    },
    content: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem',
      borderBottom: '2px solid #000000',
      paddingBottom: '1.5rem'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#555555',
      fontWeight: '300'
    },
    clientsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
      gap: '2rem',
      marginTop: '3rem'
    },
    clientCard: {
      border: '1px solid #eeeeee',
      borderRadius: '8px',
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      ':hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
      }
    },
    clientLogo: {
      width: '120px',
      height: '120px',
      backgroundColor: '#f5f5f5',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '1.5rem',
      overflow: 'hidden'
    },
    clientLogoImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    clientName: {
      fontSize: '1.3rem',
      fontWeight: '600',
      marginBottom: '0.5rem',
      color: '#000000',
      textAlign: 'center'
    },
    clientIndustry: {
      fontSize: '0.9rem',
      color: '#777777',
      marginBottom: '1rem',
      backgroundColor: '#f5f5f5',
      padding: '0.3rem 0.8rem',
      borderRadius: '20px'
    },
    clientTestimonial: {
      fontStyle: 'italic',
      color: '#555555',
      textAlign: 'center',
      marginBottom: '1.5rem',
      fontSize: '0.95rem'
    },
    sectionTitle: {
      fontSize: '1.8rem',
      fontWeight: '600',
      color: '#000000',
      borderBottom: '1px solid #eeeeee',
      paddingBottom: '0.5rem',
      margin: '3rem 0 1.5rem'
    },
    statsContainer: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      margin: '3rem 0',
      gap: '1rem'
    },
    statItem: {
      textAlign: 'center',
      padding: '1.5rem',
      minWidth: '200px'
    },
    statNumber: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem'
    },
    statLabel: {
      fontSize: '1rem',
      color: '#777777'
    },
    loading: {
      textAlign: 'center',
      fontSize: '1.2rem',
      margin: '2rem 0'
    },
    error: {
      textAlign: 'center',
      color: 'red',
      margin: '2rem 0'
    }
  };

  // فصل الشركاء الاستراتيجيين عن العملاء العاديين
  const strategicPartners = clientsData.filter(client => client.isStrategic);
  const regularClients = clientsData.filter(client => !client.isStrategic);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <header style={styles.header}>
          <h1 style={styles.title}>عملائي</h1>
          <p style={styles.subtitle}>شركاء النجاح الذين عملت معهم على مشاريع مميزة</p>
        </header>

        {loading && <div style={styles.loading}>جاري تحميل البيانات...</div>}
        {error && <div style={styles.error}>حدث خطأ في جلب البيانات: {error}</div>}

        {!loading && (
          <>
            <div style={styles.statsContainer}>
              {statsData.map((stat, index) => (
                <div key={index} style={styles.statItem}>
                  <div style={styles.statNumber}>{stat.number}</div>
                  <div style={styles.statLabel}>{stat.label}</div>
                </div>
              ))}
            </div>

            <div style={styles.clientsGrid}>
              {regularClients.map((client) => (
                <div key={client.id} style={styles.clientCard}>
                  <div style={styles.clientLogo}>
                    {client.logo ? (
                      <img src={client.logo} alt={client.name} style={styles.clientLogoImage} />
                    ) : (
                      client.logoText
                    )}
                  </div>
                  <h3 style={styles.clientName}>{client.name}</h3>
                  <span style={styles.clientIndustry}>{client.industry}</span>
                  <p style={styles.clientTestimonial}>"{client.testimonial}"</p>
                </div>
              ))}
            </div>

            {strategicPartners.length > 0 && (
              <>
                <h2 style={styles.sectionTitle}>شركاء استراتيجيون</h2>
                
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  flexWrap: 'wrap', 
                  gap: '2rem',
                  padding: '2rem',
                  backgroundColor: '#f9f9f9',
                  borderRadius: '8px'
                }}>
                  {strategicPartners.map((partner) => (
                    <div key={partner.id} style={{ 
                      width: '150px', 
                      height: '100px', 
                      backgroundColor: '#f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px'
                    }}>
                      {partner.logo ? (
                        <img src={partner.logo} alt={partner.name} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                      ) : (
                        partner.name
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Clients;